import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ShareThisViewDialogComponent } from './share-this-view-dialog.component';
import {
  AccessLink,
  AccessLinksService,
  CreateAccessLinkRequest,
  InvitationsService,
} from 'ldt-identity-service-api';
import { NotificationService } from '../notification-service/notification.service';
import { AuthService } from 'src/app/auth/service/auth.service';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ShareThisViewService {
  constructor(
    private dialog: MatDialog,
    private invService: InvitationsService,
    private notifyService: NotificationService,
    private auth: AuthService,
    private accessLinkService: AccessLinksService
  ) {}

  showShareDialog(orgId: string, redirectUrl: string, config: any) {
    const dialogRef = this.dialog.open(ShareThisViewDialogComponent, {
      // width is set in the dialog component styles
      panelClass: 'share-this-view-dialog',
      backdropClass: 'darker-dialog-backdrop',
      data: {
        orgId,
        redirectUrl,
        config,
      },
    });
  }

  createPublicLink(orgId: string, redirectUrl: string, config: any): Observable<AccessLink | null> {
    return this.createAccessLink(
      orgId,
      redirectUrl,
      config,
      CreateAccessLinkRequest.ScopeEnum.Public
    );
  }

  createPrivateLink(
    orgId: string,
    redirectUrl: string,
    config: any
  ): Observable<AccessLink | null> {
    return this.createAccessLink(orgId, redirectUrl, config, CreateAccessLinkRequest.ScopeEnum.Org);
  }

  private createAccessLink(
    orgId: string,
    redirectUrl: string,
    config: any,
    scope: CreateAccessLinkRequest.ScopeEnum
  ): Observable<AccessLink | null> {
    const req: CreateAccessLinkRequest = {
      type: CreateAccessLinkRequest.TypeEnum.SharedView,
      config: config,
      redirect_url: redirectUrl,
      scope: scope,
    };

    return this.accessLinkService.createAccessLink(orgId, req).pipe(
      catchError((error) => {
        console.error(`Error generating ${scope} link`, error);
        this.notifyService.error(`Failed to generate link. Please try again.`);
        return of(null);
      })
    );
  }
}
